import { BrandColors, Colors } from "@/constants/theme";
import { useColorScheme } from "@/hooks/use-color-scheme";
import { ActivityIndicator, StyleSheet, View, ViewStyle } from "react-native";

interface LoaderProps {
  inline?: boolean;
  style?: ViewStyle;
}

export function Loader({ inline = false, style }: LoaderProps) {
  const colorScheme = useColorScheme();
  const theme = Colors[colorScheme ?? "light"];

  return (
    <View
      style={[
        inline ? styles.inlineContainer : styles.container,
        !inline && { backgroundColor: theme.background },
        style,
      ]}
    >
      <ActivityIndicator size="large" color={BrandColors.primary} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  inlineContainer: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    paddingVertical: 48,
  },
});
